import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  ExternalLink,
  Icon,
  Link,
  ListRow,
  Menu,
  MenuHeading,
  MenuSection,
  MenuSeparator,
} from 'next/components/ui';
import useToggle from 'next/hooks/use-toggle';
import { selectAccount, Shape as MetaShape } from 'next/entities/account';
import { selectAccounts, Shape as AccountShape } from 'next/entities/accounts';
import { logout, selectUser, Shape as UserShape } from 'next/entities/user';
import AccountMenuButton from './AccountMenuButton';
import { AccountMenuContent } from './styled';

export const AccountMenu = ({
  account,
  accounts,
  onLogout,
  open = false,
  user,
}) => {
  const [openState, toggle] = useToggle(open);

  const { company } = account ?? {};
  const { email, fullname: name } = user ?? {};

  const label = company || email;

  const count = Object.keys(accounts ?? {}).length;

  return (
    <Menu onOpenChange={toggle} open={openState}>
      <AccountMenuButton company={label} name={name} open={openState} />

      <AccountMenuContent align="end" side="right" sideOffset={12}>
        <MenuSection>
          {count > 1 ? (
            <ListRow
              forwardedAs={Link}
              description="Switch accounts"
              to="/accounts"
            >
              {label}
            </ListRow>
          ) : (
            <MenuHeading title={label}>{label}</MenuHeading>
          )}
        </MenuSection>

        <MenuSeparator />

        <MenuSection>
          <ListRow forwardedAs={Link} to="/settings">
            Settings
          </ListRow>
          <ListRow forwardedAs={Link} to="/diagnostics">
            Diagnostics
          </ListRow>
          <ListRow
            forwardedAs={ExternalLink}
            href="https://status.appcues.com/"
            icon={false}
          >
            Appcues status
          </ListRow>
        </MenuSection>

        <MenuSeparator />

        <MenuSection>
          <ListRow onClick={onLogout} suffix={<Icon icon="sign-out-alt" />}>
            Sign out
          </ListRow>
        </MenuSection>
      </AccountMenuContent>
    </Menu>
  );
};

AccountMenu.propTypes = {
  account: MetaShape,
  accounts: PropTypes.objectOf(AccountShape),
  onLogout: PropTypes.func,
  open: PropTypes.bool,
  user: UserShape,
};

const mapStateToProps = state => ({
  account: selectAccount(state),
  accounts: selectAccounts(state),
  user: selectUser(state),
});

const mapDispatchToProps = {
  onLogout: logout,
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountMenu);
